{
  "collectionLabel": "Suggerimenti"
}
